var e = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, t = {
  isSsr: e()
};
export {
  t as Global
};
